import Settings from './Setting';
import CommonReducer from './CommonReducer';
import Auth from './Auth';
import ChatApp from './ChatApp';
import Courses from './Courses';
import Statistics from './Statistics';
import TMR from './TMR';

const reducers = {
  settings: Settings,
  auth: Auth,
  common: CommonReducer,
  chatApp: ChatApp,
  courses: Courses,
  statistics: Statistics,
  tmr: TMR,
};

export default reducers;
